import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/TechnicianMainPageActions";
import * as api from "../../api/TechnicianMainPageApi";
import { showErrorSnackbar, showInfoSnackbar } from "../actions/SnackbarActions";
import { resetBackdrop, setBackdrop } from "../actions/BackdropActions";

function* getUnplannedMaintenanceActiveCounts() {
    try {
        const { data } = yield api.getUnplannedMaintenanceActiveCounts();
        yield put(actions.setUnplannedMaintenanceActiveCounts(data || undefined));
    } catch (error) {
        yield put(actions.setUnplannedMaintenanceActiveCounts(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedMaintenanceActiveCounts() {
    try {
        const { data } = yield api.getPlannedMaintenanceActiveCounts();
        yield put(actions.setPlannedMaintenanceActiveCounts(data || undefined));
    } catch (error) {
        yield put(actions.setPlannedMaintenanceActiveCounts(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getNotifications(action) {
    try {
        const { data } = yield api.getNotifications(action.payload);
        yield put(actions.setNotifications(data || undefined));
    } catch (error) {
        yield put(actions.setNotifications(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBarcodeContent(action) {
    try {
        yield put(resetBackdrop());
        const data = yield api.getBarcodeContent(action.payload);
        const {
            data: { resultObject },
        } = data;
        if (resultObject.length > 0) {
            yield put(actions.setBarcodeContent(data || undefined));
        } else {
            yield put(showInfoSnackbar(data));
        }
    } catch (error) {
        //yield put(actions.setBarcodeContent(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS, getUnplannedMaintenanceActiveCounts);
    yield takeEvery(actions.Types.GET_PLANNED_MAINTENANCE_ACTIVE_COUNTS, getPlannedMaintenanceActiveCounts);
    yield takeEvery(actions.Types.GET_NOTIFICATIONS, getNotifications);
    yield takeEvery(actions.Types.GET_BARCODE_CONTENT, getBarcodeContent);
}

const TechnicianMainPageSaga = [fork(watchAll)];

export default TechnicianMainPageSaga;
